import { render } from "./DJvirtualCommerce.vue?vue&type=template&id=4e224ce0&scoped=true"
import script from "./DJvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./DJvirtualCommerce.vue?vue&type=script&lang=js"

import "./DJvirtualCommerce.vue?vue&type=style&index=0&id=4e224ce0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e224ce0"

export default script